export default __webpack_public_path__ + "static/media/IMG_20210802_081319_903.ec07f43d.jpg";